import React, { Component } from 'react'
import { LoginSmart, EsqueciPwd } from '@newspacebpo/mf_nslogin'
import DateClock from '../../../components/dateClock/DateClock'
import logo from '../../../assets/img/brand/logobf-transparente.png'
// import logo from '../../../assets/img/brand/smartcapture.png'
import versao from './package.json'

export default class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      esquecipdw: false
    }
    this.handleClickPWD = this.handleClickPWD.bind(this)
  }

  componentDidMount () {
    let btn = document.getElementById('esqueciSenha')
    if (btn) btn.addEventListener('click', this.handleClickPWD)
  }

  handleClickPWD () {
    this.setState({ esquecipdw: !this.state.esquecipdw })
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClickPWD)
  }

  render () {

    let year = new Date().getFullYear();

    return (
      <div className="customlogin">

        <DateClock className="date-time"/>

        {this.state.esquecipdw ? (
          <EsqueciPwd
            redirect='/'
            boxTitle={'Financiamento de Veículos'}
            textColorBoxTitle={'#000000'}
            bgColorBoxTitle={'rgba(255, 255, 255, .15)'}
            bgColorContainer={'rgba(255, 255, 255, .65'}
            bgColorLogo={'#FFFFFF'}
            textColor={'#000000'}
          />
        ) : (
          <LoginSmart
            redirect='/'
            esqueciSenha
            logoImg={logo}
            textColor={'#000000'}
            verifyCpfCnpj={true}
            boxTitle={'Financiamento de Veículos'}
            bgColorBoxTitle={'rgba(255, 255, 255, .7)'}
            version={versao.version}
            copyright={ year + ' New Space. Todos os direitos reservados.'}
            bgColorContainer={'rgba(255, 255, 255, .4)'}
            bgColorLogo={'#FFFFFF'}
          />
        )}
      </div>
    )
  }
}
